import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import "./index.css"

import { withRouter } from '../../utils/withRouter'
import { InputPassword } from '../../shared/CustomField'
import { Form } from 'react-form'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'

const PasswordRecovery = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [tokenValid, setTokenValid] = useState(null) // null = loading, true = valid, false = invalid
  const [tokenValidationError, setTokenValidationError] = useState('')
  // ponte V2: sob /v2 voltar/sucesso levam ao login da conta V2 (sem alert nativo)
  const isV2 = window.location.pathname.startsWith('/v2')

  // Function to extract token from URL
  const getTokenFromUrl = useCallback(() => {
    const urlParams = new URLSearchParams(location.search)
    return urlParams.get('token')
  }, [location.search])

  // Function to validate token
  const validateToken = async (token) => {
    if (!token) {
      setTokenValid(false)
      setTokenValidationError('Token não encontrado na URL')
      return
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APPSETTING_SM_PHP_API_ENDPOINT}users/password/reset/check-token`,
        { token },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data.status === 200) {
        setTokenValid(true)
      } else {
        setTokenValid(false)
        setTokenValidationError(response.data.message || 'Token inválido')
      }
    } catch (error) {
      setTokenValid(false)
      setTokenValidationError(
        error.response?.data?.message || 'Erro ao validar token. Tente novamente.'
      )
    }
  }

  // Validate token on component mount
  useEffect(() => {
    const token = getTokenFromUrl()
    validateToken(token)
  }, [getTokenFromUrl])

  // Function to go back to manage page
  const goToManage = () => {
    navigate(isV2 ? '/v2/conta/entrar' : '/admin')
  }

  // Show loading state
  if (tokenValid === null) {
    return (
      <div className="recovery-page" style={{ minHeight: '70vh', alignItems: 'flex-start', paddingTop: '10vh' }}>
        <div className="recovery-page__content">
          <h1>Criação de senha</h1>
          <p>Validando token...</p>
        </div>
      </div>
    )
  }

  // Show error state for invalid token
  if (tokenValid === false) {
    return (
      <div className="recovery-page" style={{ minHeight: '70vh', alignItems: 'flex-start', paddingTop: '10vh' }}>
        <div className="recovery-page__content">
          <h1>Token Inválido</h1>
          <p>
            Por favor, solicite um novo link de recuperação de senha ou entre em contato com o suporte.
          </p>

          <button className="button__normal button__normal--cancel" onClick={goToManage}>
            Voltar
          </button>

        </div>
      </div>
    )
  }

  const passwordCriterias = [
    {label: 'Mínimo 8 caracteres', tester: (pass) => pass && pass.length >= 8},
    {label: 'Ao menos 1 letra maiúscula', tester: (pass) => /[A-Z]{1,}/.test(pass)},
    {label: 'Ao menos 1 letra minúscula', tester: (pass) => pass && /[a-z]{1,}/.test(pass)},
    {label: 'Número de 0 a 9', tester: (pass) => pass && /[0-9]{1,}/.test(pass)},
    {label: 'Um ou mais caractere especial', tester: (pass) => /['"!@#$%¨&*()_+=´[\]~^/?;:.,><'º]{1,}/.test(pass)},
  ];

  const _validateForm = (values) => {

    return {
      password: passwordCriterias.map(criteria => !criteria.tester(values.password)).filter(Boolean).length === 0 ? undefined : 'Sua senha não segue os critérios',
      passwordConfirmation: values.password !== values.passwordConfirmation ? 'As senhas não conferem' : undefined
    }
  }

  // Function to handle password update
  const handlePasswordUpdate = async (values) => {
    const token = getTokenFromUrl()
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APPSETTING_SM_PHP_API_ENDPOINT}users/password/update`,
        { 
          token,
          password: values.password 
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data.status === 200) {
        if (isV2) {
          navigate('/v2/conta/entrar', { state: { notice: 'Senha atualizada com sucesso! Entre com a nova senha.' } })
          return
        }
        // Password updated successfully
        alert('Senha atualizada com sucesso!')
        navigate('/admin') // Redirect to login page
      } else {
        alert(response.data.message || 'Erro ao atualizar senha. Tente novamente.')
      }
    } catch (error) {
      alert(
        error.response?.data?.message || 'Erro ao atualizar senha. Tente novamente.'
      )
    }
  }

  return (
    <div className="recovery-page">
      <div className="recovery-page__content">
        <h1>Criação de senha</h1>
        <h3>Por favor digite sua nova senha abaixo</h3>

        <Form
          validate={_validateForm}
          onSubmit={handlePasswordUpdate}
        >
         {({ submitForm, values, setValue, getValue }) => {
            return (
            <form action={submitForm}>
              <div className="recovery-page__content__fields-box">
                <label>
                  Nova senha*
                  <InputPassword className="field__text" field="password" />
                </label>

                <label>
                  Confirme sua Senha*
                  <InputPassword className="field__text" field="passwordConfirmation" />
                </label>

                <div className="recovery-page__content__fields-box__acceptance-criterias">
                  <div className="criteria criteria-header">Ela precisa ter:</div>
                  {passwordCriterias.map((criteria, index) => (
                    <div key={index} className={`criteria ${!criteria.tester(values.password) ? 'error' : 'success'}`}>
                      <i className={`fa fa-${!criteria.tester(values.password) ? 'times' : 'check'}`} aria-hidden="true"></i>
                      {criteria.label}
                    </div>
                  ))}
                </div>

                <div className="recovery-page__content__fields-box__buttons">
                  <button className="button__normal button__normal--cancel" type="button" onClick={() => goToManage()}>
                    Cancelar
                  </button>
                  <button className="button__normal" type="button" onClick={submitForm}>
                    Salvar
                  </button>
                </div>
              </div>
            </form>
          )}
          } 
        </Form>
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => ({
})

const mapDispatchToProps =  {
}

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...props,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(PasswordRecovery))

